import React from 'react';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { TalentGap } from './components/TalentGap';
import { PainPoints } from './components/PainPoints';
import { RealProblem } from './components/RealProblem';
import { MethodIntro } from './components/MethodIntro';
import { Testimonials } from './components/Testimonials';
import { OfferStack } from './components/OfferStack';
import { Pricing } from './components/Pricing';
import { Faq } from './components/Faq';
import { Guarantee } from './components/Guarantee';
import { TwoPaths } from './components/TwoPaths';
import { SiteFooter } from './components/SiteFooter';
import { MobileCtaBar } from './components/MobileCtaBar';
export function App() {
  return <div className="w-full bg-cream pb-[76px] lg:pb-0" data-id="element-0" data-mp="2wi5nzkmk8rqd">
      <CountdownBar data-id="element-1" data-mp="28t4m6g88geu2" />
      <Hero data-id="element-2" data-mp="28sl48zil1qg1" />
      <main data-id="element-3" data-mp="28sbend1g9lav">
        <TalentGap data-id="element-4" data-mp="23vck4tdvjcc5" />
        <PainPoints data-id="element-5" data-mp="23vuq4hqc94x9" />
        <RealProblem data-id="element-6" data-mp="23u9q4cl98ts0" />
        <MethodIntro data-id="element-7" data-mp="23v2s7099qv3t" />
        <Testimonials data-id="element-8" data-mp="23ti6m04xmmi3" />
        <OfferStack data-id="element-9" data-mp="3ikh8ubu2yx01" />
        <Pricing data-id="element-10" data-mp="3iiwf2oflbi38" />
        <Faq data-id="element-11" data-mp="3ijfv1zlojwem" />
        <Guarantee data-id="element-12" data-mp="3ihv1odb3qjic" />
        <TwoPaths data-id="element-13" data-mp="3mljat0fdtn5p" />
      </main>
      <SiteFooter data-id="element-14" data-mp="3mkrc3gqhn9b7" />
      <MobileCtaBar data-id="element-15" data-mp="3mk84asujy1aw" />
    </div>;
}